module.exports = [
  require('./nalfeshnee'),
  require('./needle_blight'),
  require('./night_hag'),
  require('./nightmare'),
  require('./noble'),
  require('./nothic'),
  require('./nycaloth'),
]
